import createIcon from '../../createIcon';

/**
 * @component @name Stop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiA2SDE4VjE4SDZWNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Stop = createIcon('Stop', [['path', { d: 'M6 6H18V18H6V6Z', key: '1ieknm' }]]);

export default Stop;
